import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identifying the Cycle (Without Blame)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t judge. I recognize the pattern: pursue–distance."
    ],
      [
      "Daily intention: Today I don’t judge. I recognize the pattern: pursue–distance."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This is a pattern. I am not ‘broken.’”",
      "Short mindfulness:",
      "I notice: am I clinging right now or pulling away?"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This is a pattern. I am not ‘broken.’”",
      "Short mindfulness:",
      "I notice: am I clinging right now or pulling away?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "In which moments do I become “the pursuer”? And in which moments do I become “the distancer”?\n[Write here]",
      "What is the most common trigger that turns on the cycle for us?\n[Write here]",
      "What do I do immediately when the pattern turns on? (phone / tone / silence / blame)\n[Write here]"
    ],
      [
      "In which moments do I become “the pursuer”? And in which moments do I become “the distancer”?\n[Write here]",
      "What is the most common trigger that turns on the cycle for us?\n[Write here]",
      "What do I do immediately when the pattern turns on? (phone / tone / silence / blame)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I recognize the cycle. Recognition is the beginning of freedom."
    ],
      [
      "Closing",
      "Today I recognize the cycle. Recognition is the beginning of freedom."
    ]
    ),
    action: localizedGenderNode(
      "Once today when it begins — I do a “20-second pause”: one breath + the sentence in my heart: “This is the cycle.”",
      "Once today when it begins — I do a “20-second pause”: one breath + the sentence in my heart: “This is the cycle.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What Pursuing Is Really Looking For",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I discover: pursuing is looking for safety, not victory."
    ],
      [
      "Daily intention: Today I discover: pursuing is looking for safety, not victory."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m seeking closeness, not a fight.”",
      "Short mindfulness:",
      "I ask: what is my need right now — underneath the urge?"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m seeking closeness, not a fight.”",
      "Short mindfulness:",
      "I ask: what is my need right now — underneath the urge?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When I “pursue” — what am I trying to get? (peace / reassurance / response / love)\n[Write here]",
      "What scares me most if there is no response?\n[Write here]",
      "What is one clean sentence I would like to say instead of flooding?\n[Write here]"
    ],
      [
      "When I “pursue” — what am I trying to get? (peace / reassurance / response / love)\n[Write here]",
      "What scares me most if there is no response?\n[Write here]",
      "What is one clean sentence I would like to say instead of flooding?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When the need is clear — the tone calms."
    ],
      [
      "Closing",
      "When the need is clear — the tone calms."
    ]
    ),
    action: localizedGenderNode(
      "I write one clean sentence: “I need __ right now” (without blame).",
      "I write one clean sentence: “I need __ right now” (without blame)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What Distancing Is Really Protecting",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand: distancing is protection, not cruelty."
    ],
      [
      "Daily intention: Today I understand: distancing is protection, not cruelty."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “My distance is trying to protect me.”",
      "Short mindfulness:",
      "I notice: is my body going into “shutdown”?"
    ],
      [
      "I pause with myself.",
      "One breath. “My distance is trying to protect me.”",
      "Short mindfulness:",
      "I notice: is my body going into “shutdown”?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When I “run” — what am I trying to protect myself from? (criticism / overwhelm / failure / control)\n[Write here]",
      "How does my body feel the moment I pull away?\n[Write here]",
      "What did I need to hear in order to stay one more minute?\n[Write here]"
    ],
      [
      "When I “run” — what am I trying to protect myself from? (criticism / overwhelm / failure / control)\n[Write here]",
      "How does my body feel the moment I pull away?\n[Write here]",
      "What did I need to hear in order to stay one more minute?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Distancing doesn’t mean “I don’t care.” Sometimes it means “too much.”"
    ],
      [
      "Closing",
      "Distancing doesn’t mean “I don’t care.” Sometimes it means “too much.”"
    ]
    ),
    action: localizedGenderNode(
      "When I want to disappear — I say one short sentence: “I’m overwhelmed. I need 10 minutes.”",
      "When I want to disappear — I say one short sentence: “I’m overwhelmed. I need 10 minutes.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Triggers: What Exactly Sets Us Off",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I map the points that ignite the cycle."
    ],
      [
      "Daily intention: Today I map the points that ignite the cycle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “If I recognize a trigger — I get pulled in less.”",
      "Short mindfulness:",
      "I notice: what is the first beat in my body before I react?"
    ],
      [
      "I pause with myself.",
      "One breath. “If I recognize a trigger — I get pulled in less.”",
      "Short mindfulness:",
      "I notice: what is the first beat in my body before I react?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "3 main triggers that ignite pursue–distance for us:\n[Write here]",
      "Which trigger is connected to fear of abandonment?\n[Write here]",
      "Which trigger is connected to fear of being swallowed / losing myself?\n[Write here]"
    ],
      [
      "3 main triggers that ignite pursue–distance for us:\n[Write here]",
      "Which trigger is connected to fear of abandonment?\n[Write here]",
      "Which trigger is connected to fear of being swallowed / losing myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A trigger is a warning sign — not a sentence."
    ],
      [
      "Closing",
      "A trigger is a warning sign — not a sentence."
    ]
    ),
    action: localizedGenderNode(
      "I choose one trigger and attach one anchor sentence to it: “Pause. This is a trigger.”",
      "I choose one trigger and attach one anchor sentence to it: “Pause. This is a trigger.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Body Language Instead of War",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I return to my body so I don’t ignite."
    ],
      [
      "Daily intention: Today I return to my body so I don’t ignite."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "3 slow breaths.",
      "Short mindfulness:",
      "I relax shoulders, soften jaw, release belly."
    ],
      [
      "I pause with myself.",
      "3 slow breaths.",
      "Short mindfulness:",
      "I relax shoulders, soften jaw, release belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does my body lock during conflict?\n[Write here]",
      "What helps me lower tension by 10%? (walk / water / music / shower)\n[Write here]",
      "What early sign in my body tells me “I’m about to explode / disappear”?\n[Write here]"
    ],
      [
      "Where does my body lock during conflict?\n[Write here]",
      "What helps me lower tension by 10%? (walk / water / music / shower)\n[Write here]",
      "What early sign in my body tells me “I’m about to explode / disappear”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I calm my body — I save the relationship."
    ],
      [
      "Closing",
      "When I calm my body — I save the relationship."
    ]
    ),
    action: localizedGenderNode(
      "During a trigger: water + one breath before words.",
      "During a trigger: water + one breath before words."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "“Request” Instead of “Demand”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice turning pressure into a request."
    ],
      [
      "Daily intention: Today I practice turning pressure into a request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A request brings closeness. A demand creates distance.”",
      "Short mindfulness:",
      "I check: am I coming now to receive, or to fix?"
    ],
      [
      "I pause with myself.",
      "One breath. “A request brings closeness. A demand creates distance.”",
      "Short mindfulness:",
      "I check: am I coming now to receive, or to fix?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What demand do I usually express?\n[Write here]",
      "How does it sound as a short, clean request?\n[Write here]",
      "What am I willing to accept even if the answer isn’t perfect?\n[Write here]"
    ],
      [
      "What demand do I usually express?\n[Write here]",
      "How does it sound as a short, clean request?\n[Write here]",
      "What am I willing to accept even if the answer isn’t perfect?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A good request creates room for a response."
    ],
      [
      "Closing",
      "A good request creates room for a response."
    ]
    ),
    action: localizedGenderNode(
      "I write one “golden request”: short, specific, without the past.",
      "I write one “golden request”: short, specific, without the past."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A “Safe Space” for a Talk (10 Minutes)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn to speak without activating the cycle."
    ],
      [
      "Daily intention: Today I learn to speak without activating the cycle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I want connection, not victory.”",
      "Short mindfulness:",
      "I tune my tone: quiet, slow, short sentences."
    ],
      [
      "I pause with myself.",
      "One breath. “I want connection, not victory.”",
      "Short mindfulness:",
      "I tune my tone: quiet, slow, short sentences."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is one topic I want to talk about without flooding?\n[Write here]",
      "What is the cleanest opening sentence I can say?\n[Write here]",
      "What time limit fits me for a talk so I don’t get pulled in?\n[Write here]"
    ],
      [
      "What is one topic I want to talk about without flooding?\n[Write here]",
      "What is the cleanest opening sentence I can say?\n[Write here]",
      "What time limit fits me for a talk so I don’t get pulled in?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A short, clean conversation is better than a whole night of cycle."
    ],
      [
      "Closing",
      "A short, clean conversation is better than a whole night of cycle."
    ]
    ),
    action: localizedGenderNode(
      "If there is a talk: “10 minutes only” + a pause in the middle for one breath.",
      "If there is a talk: “10 minutes only” + a pause in the middle for one breath."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Repair After a Trigger",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I learn to repair quickly — instead of punishing for days."
    ],
      [
      "Daily intention: Today I learn to repair quickly — instead of punishing for days."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Repair is possible, even if it got ugly.”",
      "Short mindfulness:",
      "I ask: what is my part in this pattern — without shame?"
    ],
      [
      "I pause with myself.",
      "One breath. “Repair is possible, even if it got ugly.”",
      "Short mindfulness:",
      "I ask: what is my part in this pattern — without shame?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I do that ignited it?\n[Write here]",
      "What would I do differently with 10% less intensity?\n[Write here]",
      "What short repair sentence fits me? (“I’m sorry about the tone…”)\n[Write here]"
    ],
      [
      "What did I do that ignited it?\n[Write here]",
      "What would I do differently with 10% less intensity?\n[Write here]",
      "What short repair sentence fits me? (“I’m sorry about the tone…”)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Repair is strength. Not weakness."
    ],
      [
      "Closing",
      "Repair is strength. Not weakness."
    ]
    ),
    action: localizedGenderNode(
      "I craft one repair sentence and keep it ready.",
      "I craft one repair sentence and keep it ready."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Creating a Proper “Time-Out”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I distinguish between a time-out and abandonment."
    ],
      [
      "Daily intention: Today I distinguish between a time-out and abandonment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “A time-out is a bridge, not an escape.”",
      "Short mindfulness:",
      "I notice: am I asking for space with respect?"
    ],
      [
      "I pause with myself.",
      "One breath. “A time-out is a bridge, not an escape.”",
      "Short mindfulness:",
      "I notice: am I asking for space with respect?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I need a time-out so I don’t explode / disappear?\n[Write here]",
      "How do I say a time-out without threatening? (one sentence)\n[Write here]",
      "What do I commit to: returning when? (a clear time)\n[Write here]"
    ],
      [
      "When do I need a time-out so I don’t explode / disappear?\n[Write here]",
      "How do I say a time-out without threatening? (one sentence)\n[Write here]",
      "What do I commit to: returning when? (a clear time)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Space with a return time = safety."
    ],
      [
      "Closing",
      "Space with a return time = safety."
    ]
    ),
    action: localizedGenderNode(
      "I write the “time-out formula”: “I need 20 minutes, I’ll come back at __.”",
      "I write the “time-out formula”: “I need 20 minutes, I’ll come back at __.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Fears Under the Cycle",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fears that activate us."
    ],
      [
      "Daily intention: Today I touch the fears that activate us."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Fears want a hug, not a war.”",
      "Short mindfulness:",
      "I notice: which main fear is rising — abandonment or engulfment?"
    ],
      [
      "I pause with myself.",
      "One breath. “Fears want a hug, not a war.”",
      "Short mindfulness:",
      "I notice: which main fear is rising — abandonment or engulfment?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "My main fear in the relationship is: __\n[Write here]",
      "What do I do when I’m afraid? (pursue / distance / criticize / go silent)\n[Write here]",
      "What is one gentle truth I can tell myself when fear rises?\n[Write here]"
    ],
      [
      "My main fear in the relationship is: __\n[Write here]",
      "What do I do when I’m afraid? (pursue / distance / criticize / go silent)\n[Write here]",
      "What is one gentle truth I can tell myself when fear rises?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I see fear — I turn it into attack less."
    ],
      [
      "Closing",
      "When I see fear — I turn it into attack less."
    ]
    ),
    action: localizedGenderNode(
      "Anchor sentence: “This is fear. It doesn’t have to lead to action.”",
      "Anchor sentence: “This is fear. It doesn’t have to lead to action.”"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Boundaries and Needs (Without War)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I phrase a clean need and a clean boundary."
    ],
      [
      "Daily intention: Today I phrase a clean need and a clean boundary."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I can be clear and gentle.”",
      "Short mindfulness:",
      "I check: what do I need to feel safe?"
    ],
      [
      "I pause with myself.",
      "One breath. “I can be clear and gentle.”",
      "Short mindfulness:",
      "I check: what do I need to feel safe?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "One need I tend to hide in the relationship:\n[Write here]",
      "One boundary I need so I don’t burn out:\n[Write here]",
      "How do I say it in first person, without “you always”?\n[Write here]"
    ],
      [
      "One need I tend to hide in the relationship:\n[Write here]",
      "One boundary I need so I don’t burn out:\n[Write here]",
      "How do I say it in first person, without “you always”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary is protection, not punishment."
    ],
      [
      "Closing",
      "A boundary is protection, not punishment."
    ]
    ),
    action: localizedGenderNode(
      "I write one short, clean boundary sentence.",
      "I write one short, clean boundary sentence."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "What Is Right for Me in This Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check compatibility, not only fear."
    ],
      [
      "Daily intention: Today I check compatibility, not only fear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m not only reacting. I’m choosing.”",
      "Short mindfulness:",
      "I ask: do I feel more like me, or less like me?"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m not only reacting. I’m choosing.”",
      "Short mindfulness:",
      "I ask: do I feel more like me, or less like me?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What truly works in this relationship?\n[Write here]",
      "What doesn’t work — again and again?\n[Write here]",
      "What do I need for the cycle to calm over time?\n[Write here]"
    ],
      [
      "What truly works in this relationship?\n[Write here]",
      "What doesn’t work — again and again?\n[Write here]",
      "What do I need for the cycle to calm over time?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Knowing truth is not destroying — it is illuminating."
    ],
      [
      "Closing",
      "Knowing truth is not destroying — it is illuminating."
    ]
    ),
    action: localizedGenderNode(
      "I write 1 small change I ask for in a clean way.",
      "I write 1 small change I ask for in a clean way."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A “Small Contract” Against the Cycle",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I build a small plan that replaces the pattern."
    ],
      [
      "Daily intention: Today I build a small plan that replaces the pattern."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Consistency is better than drama.”",
      "Short mindfulness:",
      "I ask: what small action can break the automatic?"
    ],
      [
      "I pause with myself.",
      "One breath. “Consistency is better than drama.”",
      "Short mindfulness:",
      "I ask: what small action can break the automatic?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is our #1 trigger?\n[Write here]",
      "What is the new “first step” instead of pursuing / distancing?\n[Write here]",
      "What is the agreed sentence I say to myself when it turns on?\n[Write here]"
    ],
      [
      "What is our #1 trigger?\n[Write here]",
      "What is the new “first step” instead of pursuing / distancing?\n[Write here]",
      "What is the agreed sentence I say to myself when it turns on?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A pattern changes through a small move that repeats."
    ],
      [
      "Closing",
      "A pattern changes through a small move that repeats."
    ]
    ),
    action: localizedGenderNode(
      "I write a one-line “inner contract”: “When _, I do _.”",
      "I write a one-line “inner contract”: “When _, I do _.”"
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure: Choosing Me Inside a Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t have to be perfect. I stay loyal to myself."
    ],
      [
      "Daily intention: Today I don’t have to be perfect. I stay loyal to myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One deep breath. “I choose connection without losing myself.”",
      "Short mindfulness:",
      "I notice: the most important thing for me to keep is self-respect."
    ],
      [
      "I pause with myself.",
      "One deep breath. “I choose connection without losing myself.”",
      "Short mindfulness:",
      "I notice: the most important thing for me to keep is self-respect."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about myself in this journey?\n[Write here]",
      "What is clearer to me now about our pattern?\n[Write here]",
      "A return sentence for hard days (short, clear):\n[Write here]"
    ],
      [
      "What did I learn about myself in this journey?\n[Write here]",
      "What is clearer to me now about our pattern?\n[Write here]",
      "A return sentence for hard days (short, clear):\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I am not only “the pursuer” and not only “the distancer.”",
      "I am a person seeking safety and love.",
      "And today I’m learning to pause, breathe, and choose a response.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I am not only “the pursuer” and not only “the distancer.”",
      "I am a person seeking safety and love.",
      "And today I’m learning to pause, breathe, and choose a response.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "I choose one action that symbolizes change: a clean message / a proper time-out / a short request.",
      "I choose one action that symbolizes change: a clean message / a proper time-out / a short request."
    ),
  },
].map(buildNormalizedDay);

export const pursuerDistancerCycleBlueprintEn = buildNormalizedPilotBlueprint({
  id: "pursuer_distancer_cycle_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "pursuer_distancer_cycle",
  category: "general",
  journeyName: {
    he: "מעגל רודף–נמנע",
    en: "Pursuer–Distancer Cycle",
    es: "Ciclo Perseguidor–Evitador",
  },
  days,
});

export default pursuerDistancerCycleBlueprintEn;
